import { brasaoIndeaNovoBase64 } from "@/assets/brasaoIndeaNovoBase64";
import { logoIndeaAzulBase64 } from "@/assets/logoIndeaAzulBase64";
import { TIPO_INSPECAO } from "@/constants/TIPO_INSPECAO";
import { ITermoNotificacao } from "@/interfaces/ITermoNotificacao";
import { cnpjMask } from "@/utils/cnpjMask";
import { cpfMask } from "@/utils/cpfMask";
import dayjs from "dayjs";
import { forwardRef } from "react";
import styles from "./style.module.css";

interface ImpressaoTermoNotificacaoProps {
  marcadagua?: string;
  item: ITermoNotificacao | null;
}

export const ImpressaoTermoNotificacao = forwardRef<
  HTMLDivElement,
  ImpressaoTermoNotificacaoProps
>(({ marcadagua, item }: ImpressaoTermoNotificacaoProps, ref) => {
  return (
    <div ref={ref}>
      <div className={styles["marcadagua-brasao"]}>
        <img src={`${brasaoIndeaNovoBase64}`} alt="brasao" />
      </div>

      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.logoHeader}>
            <img
              src={`${logoIndeaAzulBase64}`}
              alt="logo"
              style={{
                width: 250,
              }}
            />
          </div>

          <div className={styles.titleHeader}>
            <h1>
              <strong>
                INSTITUTO DE DEFESA AGROPECUÁRIA DO ESTADO DE MATO GROSSO
              </strong>
              <br />
              VINCULADO A SECRETARIA DE ESTADO DE DESENVOLMENTO ECONÔMICO
              COORDENADORIA DE INSPEÇÃO SANITÁRIA DE PRODUTOS DE ORIGEM ANIMAL
              CISPOA
            </h1>
          </div>
        </div>

        <h1 className={styles.termoTitle}>
          TERMO DE NOTIFICAÇÃO {item?.numero}{" "}
          {marcadagua === "MINUTA" && "- MINUTA"}
        </h1>

        <table className={styles.infoTable}>
          <colgroup>
            <col style={{ width: "30%" }} />
            <col style={{ width: "70%" }} />
          </colgroup>
          <tbody>
            <tr>
              <td>
                N°{" "}
                {item?.estabelecimento
                  ? TIPO_INSPECAO[item.estabelecimento.tipoInspecao]
                  : "SISE"}
                :
              </td>
              <td>{item?.estabelecimento.numeroInspecao}</td>
            </tr>
            <tr>
              <td>RAZÃO SOCIAL:</td>
              <td>{item?.estabelecimento.nome}</td>
            </tr>
            <tr>
              <td>NOME FANTASIA:</td>
              <td>{item?.estabelecimento.apelido}</td>
            </tr>
            <tr>
              <td>CNPJ:</td>
              <td>{cnpjMask(item?.estabelecimento.cpfCnpj || "")}</td>
            </tr>
            <tr>
              <td>MUNICÍPIO:</td>
              <td>
                {item?.estabelecimento.endereco.municipio.nome}/
                {item?.estabelecimento.endereco.municipio.uf.sigla}
              </td>
            </tr>
          </tbody>
        </table>

        <p className={styles.introText}>
          Após vistoria realizada neste estabelecimento e de acordo com a
          legislação vigente que dispõe sobre a inspeção sanitária estadual e
          que em virtude da(s) irregularidade(s), verificada(s) abaixo
          relacionada(s):
        </p>

        <div className={styles.sectionMotivos}>
          <p>Motivos:</p>
          <ul>
            {item?.motivos.map((motivo, index) => (
              <li key={index}>{motivo.nome.toUpperCase()}</li>
            ))}
          </ul>
        </div>

        {item?.motivos.find((motivo) => motivo.id === 3 || motivo.id === 4) && (
          <div className={styles.sectionDescricao}>
            <p>Observação:</p>
            <p>
              Fica Vossa Senhoria devidamente notificada de que, em caso de
              reincidência, o estabelecimento industrial estará sujeito à
              suspensão de seu registro, nos termos do art. 15, inciso IV, da
              Lei nº 13.014, de 29 de agosto de 2025.
            </p>
          </div>
        )}

        <div className={styles.sectionDescricao}>
          <p>Descrição:</p>
          <p>{item?.teor}</p>
        </div>

        <div style={{ display: "flex", fontSize: 11 }}>
          <div style={{ width: "50%" }}>
            <span>
              Exige Plano de Ação? {item?.exigeSaneamento ? "Sim" : "Não"}
            </span>
          </div>

          {item?.exigeSaneamento && (
            <div style={{ width: "50%" }}>
              <span>
                Prazo Atendimento:{" "}
                {item.prazoAtendimento
                  ? dayjs(item?.prazoAtendimento).format("DD/MM/YYYY")
                  : "-"}
              </span>
            </div>
          )}
        </div>

        <p className={styles.notificationText}>
          Fica Vossa Senhoria notificado a partir da presente data. Terá o prazo
          regulamentar conforme estabelecido acima para atendimento. O não
          cumprimento dessa notificação ficará sujeito à penalidade prevista em
          Lei.
        </p>

        <div className={styles.dataLocal}>
          <p>
            Data:{" "}
            {item?.dataCadastro
              ? dayjs(item?.dataCadastro).format("DD/MM/YYYY")
              : dayjs().format("DD/MM/YYYY")}
          </p>
        </div>

        <table className={styles.tableAssinatura}>
          <colgroup>
            <col style={{ width: "50%" }} />
            <col style={{ width: "50%" }} />
          </colgroup>
          <tbody>
            <tr>
              <td colSpan={1}>
                <div
                  className={styles.containerAssinatura}
                  style={{ width: 300 }}
                >
                  {item?.statusAssinaturaFiscalizado === "AUSENTE" && (
                    <span style={{ fontWeight: "bold" }}>AUSENTE</span>
                  )}

                  {item?.statusAssinaturaFiscalizado === "IMPOSSIBILITADO" && (
                    <span style={{ fontWeight: "bold" }}>IMPOSSIBILITADO</span>
                  )}

                  {item?.statusAssinaturaFiscalizado === "NAO_ALFABETIZADO" && (
                    <span style={{ fontWeight: "bold" }}>NAO ALFABETIZADO</span>
                  )}

                  {item?.statusAssinaturaFiscalizado === "RECUSADO" && (
                    <span style={{ fontWeight: "bold" }}>RECUSADO</span>
                  )}

                  {item?.assinaturaFiscalizado && (
                    <img
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                      src={item?.assinaturaFiscalizado}
                      alt="Assinatura Responsavel pelo estabelecimento"
                    />
                  )}
                </div>

                <div style={{ marginTop: 10 }}>
                  <span>Nome: {item?.nomeAssinanteFiscalizado}</span>
                </div>

                <div style={{ marginTop: 10 }}>
                  <span>
                    CPF: {cpfMask(item?.cpfAssinanteFiscalizado || "")}
                  </span>
                </div>

                <div style={{ marginTop: 10 }}>
                  <span>Função: {item?.funcaoAssinanteFiscalizado}</span>
                </div>

                <div style={{ marginTop: 10 }}>
                  <span>Proprietário/Representante legal</span>
                </div>
              </td>

              <td colSpan={1}>
                <div
                  className={styles.containerAssinatura}
                  style={{ width: 300 }}
                >
                  {item?.statusAssinaturaFiscalizado === "AUSENTE" && (
                    <span style={{ fontWeight: "bold" }}>AUSENTE</span>
                  )}

                  {item?.statusAssinaturaFiscalizado === "IMPOSSIBILITADO" && (
                    <span style={{ fontWeight: "bold" }}>IMPOSSIBILITADO</span>
                  )}

                  {item?.statusAssinaturaFiscalizado === "NAO_ALFABETIZADO" && (
                    <span style={{ fontWeight: "bold" }}>NAO ALFABETIZADO</span>
                  )}

                  {item?.statusAssinaturaFiscalizado === "RECUSADO" && (
                    <span style={{ fontWeight: "bold" }}>RECUSADO</span>
                  )}

                  {item?.assinaturaServidor && (
                    <img
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                      src={item?.assinaturaServidor}
                      alt="Assinatura Responsavel pelo estabelecimento"
                    />
                  )}
                </div>

                <div style={{ marginTop: 10 }}>
                  <span>Nome: {item?.usuario?.nome}</span>
                </div>

                <div style={{ marginTop: 10 }}>
                  <span>CPF: {cpfMask(item?.usuario?.cpfCnpj || "")}</span>
                </div>

                <div style={{ marginTop: 10 }}>
                  <span>Função: NOTIFICANTE</span>
                </div>

                <div style={{ marginTop: 10 }}>
                  <span>Carimbo e assinatura do médico veterinario</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
});
